export default {
  xs: '552px',
  sm: '768px',
  md: '992px',
  lg: '1200px'
};
